module.exports = "/_next/static/images/tips-a7b056ff1c7f492168604b9e330f1c99.svg";